import { useTranslation } from '@thoughtspot/i18n';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography/typography';
import React from 'react';
import styles from '../../../styles/kpi.module.scss';
import { TEST_IDS } from './constants';
export const CCAErrorModal = React.memo(({ isOpen, onClose }) => {
    const { t } = useTranslation();
    return (React.createElement(Modal, { isOpen: isOpen, title: t('kpi.comparisonPoint.unAvailable.errorTitle'), size: ModalSize.XSMALL, onDismiss: onClose, confirmButton: {
            text: t('Done'),
            onConfirm: onClose,
        }, modalTestId: TEST_IDS.CCA_ERROR_MODAL, customFooterClassName: styles.comparisonPointErrorModalFooter },
        React.createElement(Typography, { variant: "body-normal", dataTestId: TEST_IDS.CCA_ERROR_MODAL_DESCRIPTION }, t('kpi.comparisonPoint.unAvailable.errorBody'))));
});
//# sourceMappingURL=cca-error-modal.js.map